<template>
  <span class="app-breadcrumb">
    <span v-for="item in items" v-bind:key="item.name">
        <!-- nameの変換は行わないのでapp-linkでなくrouter-linkを利用 -->
        <router-link :to="item.to">{{item.title}}</router-link>
        <i class="el-icon-arrow-right"></i>
    </span>
  </span>
</template>

<script>
/* eslint-disable semi */
import { Component } from 'vue-property-decorator';
import AppComponent from '@/app/AppComponent';
import { AppRouterHistory, RoutesMap } from '@/router';

@Component
export default class AppBreadcrumb extends AppComponent {
  get items () {
    const items = [];

    // 現在のページとそのパラメータを取得する
    // 上位ページへは現在のページのパラメータを引き渡す
    const current = this.$route;

    // 上位ページを再帰的に取得
    if (current.name in RoutesMap) {
      let parentName = RoutesMap[current.name].parent;
      while (parentName) {
        let parent = RoutesMap[parentName]

        const recentHistory = AppRouterHistory.get(parent.name);
        if (recentHistory) {
          // 直近の履歴が存在する場合は直近の履歴のパス情報を参照する
          items.push({
            name: recentHistory.name,
            title: parent.title,
            to: { path: recentHistory.path, query: recentHistory.query }
          });
        } else {
          // 直近の履歴が存在しない場合はルーター設定を参照する
          // 親画面のパラメータと自画面のパラメータで互換性がある場合(propsAlias指定有)は変換する
          //
          // 親画面のパラメータのpropsAliasが{ hoge: hage } 自画面のパラメータが{ hoge : 1 } の場合
          // 親画面には{hoge : 1, hage : 1} というパラメータを送る
          //
          // 親画面のパラメータのpropsAliasが{ hoge: hage } 自画面のパラメータが{ moge : 1 } の場合
          // 親画面には{moge : 1} というパラメータを送る(propsAliasは無視される)
          const params = {};
          Object.keys(current.params)
            .forEach(key => {
              params[key] = current.params[key];
            });
          if (('propsAlias' in parent) && (parent.propsAlias !== undefined)) {
            Object.keys(parent.propsAlias)
              .forEach(alias => {
                if (alias in current.params) {
                  params[parent.propsAlias[alias]] = current.params[alias];
                }
              });
          }

          items.push({
            name: parent.name,
            title: parent.title,
            to: { name: parent.name, params: params }
          });
        }
        parentName = parent.parent;
      }
    }

    return items.reverse();
  }
}
</script>



// WEBPACK FOOTER //
// src/app/parts/AppBreadcrumb.vue